// assets/youtubeLinks.js
// YouTube links used on the site. Each line is:
//
//   "Text shown on the website": "https://youtu.be/...",
//
// To add one, copy a line, paste it below the last one, and change the text and
// the link (keep the quotes and the comma at the end). To show it on the site,
// put its text in a portfolio folder's `links` (Pages/V2/portfolioProjects.js)
// or in the music page's SONGS (Pages/V2/MusicV2.js). Every text here must be
// different; a portfolio folder can show a shorter one (e.g. "Ep. 1").
const YOUTUBE_LINKS = {
  "Episode 1": "https://youtu.be/TY-FKSIuxkw",
  "Episode 2": "https://youtu.be/VSjDsXrPtY4",
  "Episode 3": "https://youtu.be/sggy_-3Cves",
  "I'm No God": "https://www.youtube.com/watch?v=2tydP-CQw2A",
  "Podcast Ep. 1": "https://www.youtube.com/watch?v=azgbJ8ZeX4I",
  "Podcast Ep. 2": "https://www.youtube.com/watch?v=SyQTlM0ntGc&t=18s",
  "Podcast Ep. 3": "https://www.youtube.com/watch?v=FUYJImLnaTI&t=14s",
  "Boundless San Francisco Grant": "https://www.youtube.com/watch?v=rDRnTXmwXZI",
  "Verbal Essay Ep. 1": "https://www.youtube.com/watch?v=iZvTTAoTamU&t=4s",
  "Maison KooKoo Interview": "https://www.youtube.com/watch?v=BIprMhug0cg",
  "It's Time to Invest in Waterloo": "https://www.youtube.com/watch?v=2Enu9Ueqkfc",
};

export default YOUTUBE_LINKS;
